module.exports = __webpack_public_path__ + "img/american.ede8466f.svg";